import Lottie from 'lottie-react'
import goalAnimation from '../../assets/animations/goal.json'

interface GoalIconProps {
  className?: string
  size?: number
}

const GoalIcon = ({ className = "w-14 h-14", size }: GoalIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <div className="dark:invert dark:brightness-0 dark:contrast-200 w-full h-full">
        <Lottie
          animationData={goalAnimation}
          loop={true}
          autoplay={true}
          style={{ width: size || '100%', height: size || '100%' }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet'
          }}
        />
      </div>
    </div>
  )
}

export default GoalIcon